import React,{useEffect, useState} from 'react'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { addUser } from '../../../actions/usersActions'
import { getOrigens } from '../../../actions/origensActions'
import FormUser from '../../admin/users/FormUser'
import Swal from 'sweetalert2'

export default function UserInsert() {     
    const { t } = useTranslation()
    const {user} = useSelector(state=>state.users)
    const {origens} = useSelector(state=>state.origens)
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {username, password, firstname, lastname, category, nss, dni, address, rol, origen, counter} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange  = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        })
    }

    const handleAdd = async(e) => {
        e.preventDefault()

        dispatch(addUser(username, password, firstname, lastname, category, nss, dni, address, rol, origen, counter))
        setFormState({
            username: '',
            password: '',
            firstname: '',
            lastname: '',
            category: '',
            nss: '',
            dni: '',
            address: '',
            rol: '',
            origen: '',
            counter: false
        })

        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('users.messageadd')
        })
    }

    useEffect(() => {
        setFormState({
            username: '',
            password: '',
            firstname: '',
            lastname: '',
            category: '',
            nss: '',
            dni: '',
            address: '',
            rol: '',
            origen: '',
            counter: false
        })
        dispatch(getOrigens())
    }, [user, dispatch])

    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/users`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('users.volver')}
                    </Button>
                </Row>
                <h1>{t('users.add')}</h1>
                <FormUser submit={handleAdd} isNew={true} inputChange={handleInputChange} handleCheckbox={handleCheckboxChange} state={formState} origens={origens}></FormUser>
            </Row>
        </Container>
    )
}
